// Name matching for "does this practitioner have a SimplePractice calendar?".
//
// The backend does the same matching when it hands out a link; this copy only
// decides whether to SHOW the booking button, and works from a list of names —
// no URLs are involved, so nothing sensitive is duplicated here.

const normalizeName = (value = '') =>
  String(value)
    .toLowerCase()
    .replace(/[.,'’]/g, '')
    .replace(/[-_]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

// "first ... last" -> "first last": ignores middle names and initials.
const firstLast = (normalized) => {
  const parts = normalized.split(' ').filter(Boolean);
  return parts.length < 2 ? normalized : `${parts[0]} ${parts[parts.length - 1]}`;
};

// Matching order mirrors the backend: exact -> first+last -> token subset, so
// "Maria Ylene Forwood" still matches "Ylene Forwood".
export const matchesAnyName = (practitionerName, knownNames = []) => {
  const normalized = normalizeName(practitionerName);
  if (!normalized || !knownNames.length) return false;

  const known = knownNames.map(normalizeName);
  if (known.includes(normalized)) return true;

  const fl = firstLast(normalized);
  if (known.some((name) => firstLast(name) === fl)) return true;

  const tokens = new Set(normalized.split(' ').filter(Boolean));
  return known.some((name) => name.split(' ').every((token) => tokens.has(token)));
};
